import axios from "axios";
import { tmsApi, localApi } from "../api";
import { toast } from "react-toastify";
import moment from "moment";

/**
 *
 * @returns returns the current path of the page
 */
export const getCurrentPath = () => {
  return window.location.pathname;
};

/**
 *
 * @returns returns array of user roles from localstorage if present or else an empty array
 */
export const getUserRole = () => {
  return JSON.parse(localStorage.getItem("role")) || [];
};

/**
 *
 * @returns user email used for logging into the app
 */
export const getUserEmail = () => {
  return localStorage.getItem("email");
};

/**
 *
 * @param {string} type - type of alert
 * @param {string} message - message to display in the alert
 */
export const showAlert = (type, message) => {
  switch (type) {
    case "error":
      toast.error(message, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    case "success":
      toast.success(message, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    case "warning":
      toast.warning(message, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    default:
      break;
  }
};

/**
 *
 * @param {string} dateString
 * @param {string} format - eg YYYY-MM-DD HH:mm:ss.SSS (2023-01-01 12:00:00.000)
 * @returns
 */
export const formatDateString = (dateString, format) => {
  return moment(new Date(dateString)).format(format);
};

/**
 *
 * @param {Date} momentDateTime - moment date time eg: moment(new Date())
 * @param {string} format - eg YYYY-MM-DD HH:mm:ss.SSS (2023-01-01 12:00:00.000)
 * @returns
 */
export const formatDateTime = (momentDateTime, format) => {
  return momentDateTime.format(format);
};

/**
 *
 * @param {string} name
 * @returns eg: input - Shanmukh Sai, returns - SS; input ShanmukhSai, return - S;
 */
export const getAvatarText = (name) => {
  if (!name) return "NA";
  if (name.includes(" ")) {
    return `${name.split(" ")[0].charAt(0).toUpperCase()}${name
      .split(" ")[1]
      .charAt(0)
      .toUpperCase()}`;
  } else {
    return name.charAt(0).toUpperCase();
  }
};

/**
 *
 * @returns returns user details from Location storage
 */
export const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetails");
  if (!userDetails) return {};
  return JSON.parse(userDetails);
};

/**
 *
 * @returns returns all service cities information from backend.
 */
export const getServiceCity = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + "v1/entities/servicecity", config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all cartypes used for booking from backend.
 */
export const getCarTypes = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/cartype/list/${obj.serviceCityId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getAllCarTypes = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/cartype?page=${obj.page}&size=${obj.size}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getCabs = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/findcar/${obj.serviceCityId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns Corporate company data from backend
 */
export const getCorporateClients = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + "v1/entities/corporateclientall", config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns Corporate company by service city id and travel type data from backend
 */
export const getCorporateClientsBySeviceCityIdAndTravelType = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
          `v1/entities/corporateclient/ridytype/list/${obj.serviceCityId}/${obj.travelType}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns Corporate company by service city id and travel type data from backend
 */
export const getCorporateClientsBySeviceCityIdWithoutPagination = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
          `v1/entities/corporateclient/list/${obj.serviceCityId}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns Corporate company by service city id data from backend
 */
export const getCorporateClientsBySeviceCityId = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
          `v1/entities/corporateclientall/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all cities airport data from backend
 */
export const getAirportData = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/airport/list", config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all packages data from backend
 */
export const getAllPackagesData = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/packages", config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all packages data based on service city from backend
 */
export const getPackagesByServiceCity = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  // try {
  //   return axios.get(tmsApi + `v1/entities/packages/city/${obj.serviceCityId}`, config).then((resp) => {
  //     return resp;
  //   });
  // } catch (error) {
  //   console.log("error", error);
  // }
  try {
    return axios
      .get(
        tmsApi + `v1/entities/corporatepackages/${obj.serviceCityId}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all corporate packages data based on service city from backend
 */
export const getCorporatePackagesByServiceCity = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/corporatepackages`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getTableFilterData = async (obj, body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `auth/filter?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getTableSearchData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `auth/search?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};


/**
 *
 * @returns returns all aggregators from backend
 */
export const getAggregatorData = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/aggregatoralllist", config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all aggregators from backend
 */
export const getAggregatorDataById = async (pathVariable) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/aggregator/id/"+pathVariable, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all aggregators from backend
 */
export const getAggregatorDataByServiceCityIdWithoutPagable = async (pathVariable) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/aggregator/"+pathVariable, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

/**
 *
 * @returns returns all aggregators from backend
 */
export const getAggregatorDataByServiceCityId = async (pathVariable) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/aggregatorlist/"+pathVariable, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};